import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'

export const Logo = styled.div.attrs((props) => composeTheme(props))`
  align-items: flex-start;
  display: flex;
  height: 6rem;
  justify-content: center;
  margin-bottom: 8rem;

  &.is-alt {
    margin: ${(props) => props.theme.sideMenuAlt.imageMargin};
    justify-content: left;
    padding: ${(props) => props.theme.sideMenuAlt.imagePadding};
  }
`

export const Image = styled.img.attrs((props) => composeTheme(props))`
  height: ${(props) => (props.theme.collapsed ? 'auto' : '6.0rem')};
  width: ${(props) => (props.theme.collapsed ? '4.8rem' : 'auto')};

  &.is-alt {
    height: ${(props) =>
      props.theme.collapsed
        ? props.theme.sideMenuAlt.imageIconHeight
        : props.theme.sideMenuAlt.imageHeight};
    width: ${(props) =>
      props.theme.collapsed
        ? props.theme.sideMenuAlt.imageIconWidth
        : props.theme.sideMenuAlt.imageWidth};
  }
`
